import(/* webpackMode: "eager" */ "/vercel/path0/app/energyhouse/page.tsx");
